// extracted by mini-css-extract-plugin
export default {"Grid":"DXs8UsCs","Cell":"_6wrXwGVx"};